import { Component, inject, input } from '@angular/core';
import { NineSlicedSpriteComponent } from '@features/sprites/nine-sliced-sprite/nine-sliced-sprite.component';
import { StylesService } from '@features/styles/styles.service';

@Component({
  selector: 'wk8-paper-piece',
  imports: [NineSlicedSpriteComponent],
  templateUrl: './wk8-paper-piece.component.html',
  styleUrl: './wk8-paper-piece.component.css',
})
export class Wk8PaperPieceComponent {
  readonly _stylesService = inject(StylesService);

  padding = input<'NONE' | 'SMALL' | 'LARGE'>('LARGE');
  paddingLeft = input<'NONE' | 'SMALL' | 'LARGE' | undefined>(undefined);
  paddingRight = input<'NONE' | 'SMALL' | 'LARGE' | undefined>(undefined);
  hasFocus = input<boolean>(false);
}
